import { css } from 'styled-components';
import { breakpoints } from './breakpoints';
// Usage: @media ${minWidth.md} { *CSS* }
export const minWidth = {
    xs: `(min-width: ${breakpoints.xs}px)`,
    sm: `(min-width: ${breakpoints.sm}px)`,
    md: `(min-width: ${breakpoints.md}px)`,
    lg: `(min-width: ${breakpoints.lg}px)`,
    xl: `(min-width: ${breakpoints.xl}px)`
};
export function mediaMinSm(content) {
    return css `
    @media (min-width: ${breakpoints.sm}px) {
      ${content}
    }
  `;
}
export function mediaMinMd(content) {
    return css `
    @media (min-width: ${breakpoints.md}px) {
      ${content}
    }
  `;
}
export function mediaMinLg(content) {
    return css `
    @media (min-width: ${breakpoints.lg}px) {
      ${content}
    }
  `;
}
export function mediaMinXl(content) {
    return css `
    @media (min-width: ${breakpoints.xl}px) {
      ${content}
    }
  `;
}
//# sourceMappingURL=mediaQueries.js.map